export interface City {
  _id: string;
  name: string;
  initiallyCreatedFrom?: "MANUAL" | "LOGISLY";
  initialLogislyRef?: {
    entityType?: string;
    externalId?: string;
    label?: string;
  };
}

export interface CitySearchFilters {
  name?: string;
  country?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

// Mapper functions
export const mapCityResponse = (response: any): City => {
  return {
    _id: response._id,
    name: response.name,
    initiallyCreatedFrom: response.initiallyCreatedFrom || "MANUAL",
    initialLogislyRef: response.initialLogislyRef,
  };
};

export const mapCitiesResponse = (response: any): City[] => {
  if (!response.data || !Array.isArray(response.data?.cities)) {
    return [];
  }
  return response.data.cities.map(mapCityResponse);
};
